export default __webpack_public_path__ + "static/media/2P_4P.cf9b3c3b.png";